var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"swj-category-item",on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.isIcon)?_c('Icon',{staticClass:"faq-category-icon",attrs:{"scale":"1.5","name":_vm.iconSrc}}):_c('img',{staticClass:"faq-category-icon",attrs:{"src":_vm.iconSrc}}),_vm._v(" "+_vm._s(_vm.name)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }